import { useUserTenantPreference } from 'kineticUtils/hooks';
import { MapSearchHistoryPreference } from '../types';
import { PREFERENCE_KEYS } from 'types/preferenceTypes';
import { useCallback } from 'react';

export const useMapSearchHistory = () => {
  const {
    value: { searchTerms: searchHistory = [] },
    setPreference,
  } = useUserTenantPreference<MapSearchHistoryPreference>({
    key: PREFERENCE_KEYS.MAP_SEARCH_HISTORY,
  });

  const deleteSearchHistory = useCallback(
    (searchTermToDelete: string) => {
      if (searchHistory.length === 0) {
        return;
      }
      const toSave: string[] = [...searchHistory];
      const existingTermIndex = toSave.findIndex((searchTerm) => searchTerm === searchTermToDelete);
      if (existingTermIndex >= 0) {
        toSave.splice(existingTermIndex, 1);
      }

      setPreference({ searchTerms: toSave });
    },
    [setPreference, searchHistory]
  );

  const addSearchHistory = useCallback(
    (newSearchTerm) => {
      if (searchHistory.length === 0) {
        setPreference({ searchTerms: [newSearchTerm] });
        return;
      }
      const toSave: string[] = [...searchHistory];
      const existingTermIndex = toSave.findIndex((searchTerm) => searchTerm === newSearchTerm);
      if (existingTermIndex >= 0) {
        toSave.splice(existingTermIndex, 1);
      }
      if (toSave.length >= 5) {
        toSave.pop();
      }
      toSave.unshift(newSearchTerm);
      setPreference({ searchTerms: toSave });
    },
    [setPreference, searchHistory]
  );

  return {
    addSearchHistory,
    deleteSearchHistory,
    searchHistory,
  };
};
